/**
 * Implementation of Http-client wrapper class
 */
import axios from 'axios'
import store from '@/store/'
/**
 * Application API base URL
 */
let baseURL = process.env.API_BASE_URL || '/api'

export { baseURL }

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

// Axios default params.
const defaultParams = {
  timeout: 10000
}

// Create http client
const client = axios.create(Object.assign({}, defaultParams, { baseURL }))

// Add interceptors
client.interceptors.response.use(
  response => response,
  error => {
    const status = error.response ? error.response.status : null
    const data = error.response ? error.response.data : null
    if (status === 401 && data === 'Expired') {
      return store.dispatch('auth/refresh').then(accessToken => {
        error.config.headers['Authorization'] = `Bearer ${accessToken}`
        error.config.baseURL = undefined
        return client.request(error.config)
      })
    }
    return Promise.reject(error)
  }
)

client.interceptors.request.use(
  function(config) {
    const accessToken = store.state.auth.accessToken
    if (accessToken) {
      config.headers['Authorization'] = `Bearer ${accessToken}`
    }
    return config
  },
  function(error) {
    return Promise.reject(error)
  }
)

// Export class definition & its instance.
export default client



// WEBPACK FOOTER //
// ./src/api/client.js